import { useState, useEffect } from "react";
import UseData from "./UseData";

function TrailheadDataHook() {
  const [sfCertifications, setSfCertifications] = useState(null);
  const [dataUpdationDate, setDataUpdationDate] = useState(new Date().toDateString().substring(4,).trim());
  const [isLoading, setIsLoading] = useState(true);
  const { staticSfData } = UseData();

  // const baseUrl = "/trailhead-api/";
  // const baseUrl = "https://proxy.corsfix.com/?https://profile.api.trailhead.com/graphql";
  const baseUrl = "https://cors-anywhere.herokuapp.com/profile.api.trailhead.com/graphql";

  useEffect(() => {
    // Certifications Request
    let requestBody = {
      operationName: "GetUserCertifications",
      variables: { hasSlug: true, slug: "anmoln3168" },
      query:
        "query GetUserCertifications($slug: String, $hasSlug: Boolean!) {\n  profile(slug: $slug) @include(if: $hasSlug) {\n    __typename\n    id\n    ... on PublicProfile {\n      credential {\n        certifications {\n          cta {\n            __typename\n            label\n            url\n          }\n          dateCompleted\n          dateExpired\n          downloadLogoUrl\n          logoUrl\n          infoUrl\n          maintenanceDueDate\n          product\n          publicDescription\n          status {\n            __typename\n            title\n            expired\n            date\n            color\n            order\n          }\n          title\n        }\n      }\n    }\n  }\n}\n",
    };
    let reqOptions = {
      method: "POST",
      body: JSON.stringify(requestBody),
      headers: {
        "Content-Type": "application/json",
      },
    };
    fetch(baseUrl, reqOptions)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Response was not OK");
        }
        return response.json();
      })
      .then((data) => {
        // console.dir(data);
        let resVar = data["data"]["profile"]["credential"]["certifications"];
        resVar.forEach((eachCert) => {
          delete eachCert["cta"];
          delete eachCert["product"];
          eachCert["status"] = eachCert["status"]["title"];
        });
        // console.dir(resVar);
        return resVar;
      })
      .then((cleanData) => {
        let finalData = [];
        let actualData = [...cleanData].reverse();
        actualData.forEach((ele) => {
          finalData.push({
            id: Math.floor(100000 + Math.random() * 900000),
            date: new Date(ele.dateCompleted).toDateString().substring(4,).trim(),
            title: ele.title,
            description: ele.publicDescription,
            logoUrl: ele.logoUrl,
          });
        });
        finalData.sort((a, b) => new Date(b.date) - new Date(a.date));
        setSfCertifications(finalData);
        setIsLoading(false);
      })
      .catch((err) => {
        setSfCertifications(staticSfData.staticSfCertificates);
        setDataUpdationDate(new Date(staticSfData.staticDataUpdationDate).toDateString().substring(4,).trim());
        setIsLoading(false);
      });
  }, [staticSfData]);

  return {
    dataUpdationDate,
    isLoading,
    sfCertifications,
  };
}
export default TrailheadDataHook;
